module.exports = __webpack_public_path__ + "static/media/eyescan7.f3e03f4b.png";